import { memo, useCallback, useRef, useState } from 'react'
import {ExtraSmallButton, NonInteractiveTooltip} from "../../custom"
import SettingsOutlinedIcon from "../../../assets/icons/SettingOutlined"
import OptionChainSettingsDialog from "../../../pages/home/fnoHeader/optionsChainSettingsDialog"
import {useStyles} from "./styles"
import { OptionChainViewKey } from '../../../assets/constants'

const OptionChainSettings = ({ orderOptionChain = false, optionChainViewKey }: { orderOptionChain?: boolean, optionChainViewKey?: OptionChainViewKey }) => {
    const [openSettingsAnchorEl, setOpenSettingsAnchorEl] = useState<HTMLElement>()
    const settingsButtonRef = useRef<HTMLButtonElement>(null)
    const { classes } = useStyles()

    const handleOpenSettings = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        setOpenSettingsAnchorEl((v) => (v ? undefined : e.currentTarget))
    }, [])

    return (
        <>
            <NonInteractiveTooltip title="Settings" arrow placement="top">
                <ExtraSmallButton
                    id="option-chain-settings-button"
                    ref={settingsButtonRef}
                    data-event="Settings Clicked"
                    data-event-source="option-chain-bar"
                    onClick={handleOpenSettings}
                    className={classes.item}
                    color="inherit"
                >
                    <SettingsOutlinedIcon fontSize="small" />
                </ExtraSmallButton>
            </NonInteractiveTooltip>
            <OptionChainSettingsDialog
                orderOptionChain={orderOptionChain}
                optionChainViewKey={optionChainViewKey}
                open={openSettingsAnchorEl}
                setOpen={setOpenSettingsAnchorEl}
                settingsButtonRef={settingsButtonRef}
            />
        </>
    )
}

export default memo(OptionChainSettings)